import React, { useState } from "react";
import { QRCodeCanvas } from "qrcode.react";
import { Button, Modal, Box, Typography } from "@mui/material";

const ApkDownloadQR = () => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const apkUrl =
    "https://drive.google.com/uc?export=download&id=1liMJVzU1_PxAnMBKnE1UI8_ZRLyVJ6ry";

  return (
    <div>
      <Button
        onClick={() => setIsModalOpen(true)}
        variant="contained"
        sx={{
          backgroundColor: "#6a0dad",
          color: "#fff",
          "&:hover": { backgroundColor: "#580b9a" },
        }}
      >
        Download App
      </Button>

      <Modal
        open={isModalOpen}
        onClose={() => setIsModalOpen(false)}
        aria-labelledby="qr-modal-title"
        aria-describedby="qr-modal-description"
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          backdropFilter: "blur(5px)", // Blurred background effect
        }}
      >
        <Box
          sx={{
            backgroundColor: "white",
            p: 4,
            borderRadius: 3,
            boxShadow: 24,
            textAlign: "center",
            width: 320,
            maxWidth: "90%",
            position: "relative",
          }}
        >
          <Typography id="qr-modal-title" variant="h6" fontWeight="bold" mb={2}>
            Scan to Download in Mobile
          </Typography>

          <Box display="flex" justifyContent="center" mb={2}>
            <QRCodeCanvas value={apkUrl} size={180} />
          </Box>

          <Typography
            id="qr-modal-description"
            variant="body2"
            color="textSecondary"
          >
            Scan this QR code to download the app.
          </Typography>

          <Button
            variant="contained"
            sx={{
              mt: 3,
              backgroundColor: "#6a0dad",
              color: "#fff",
              "&:hover": { backgroundColor: "#580b9a" },
            }}
            onClick={() => setIsModalOpen(false)}
          >
            Close
          </Button>
        </Box>
      </Modal>
    </div>
  );
};

export default ApkDownloadQR;
